<template>
  <div class="authentication-container">
    <div class="authentication-overlay">
      <div
        id="authentication-content"
        class="authentication-content"
      >
        <div style="text-align: center">
          <mastery-icon />
        </div>
        <div
          class="box"
          :class="{shake: shake}"
        >
          <div class="text-lg font-semibold title">
            {{ signinTitle }}
          </div>
          <div class="text-sm font-regular subtitle">
            {{ signinSubTitle }}
          </div>
          <auth-mastery-input
            :error="errors['email']"
            :field="email"
            label="Email"
            placeholder="Enter your email"
            type="email"
            @enter="submit"
            @inputChange="handleInputChange($event, 'email')"
          />
          <auth-mastery-input
            :error="errors['password']"
            :field="password"
            label="Password"
            placeholder="Enter your password"
            type="password"
            @enter="submit"
            @inputChange="handleInputChange($event, 'password')"
          />
          <button
            class="button-reset button-primary font-semibold margin-bottom-1"
            :class="{ disabled: loading }"
            data-test="sign-in-button"
            @click="submit"
          >
            Continue
          </button>
          <div class="flexbox-row">
            <span class="text-sm font-semibold link-underline">
              <router-link :to="{ name: 'mastery#signUp' }">
                Create an account
              </router-link>
            </span>
            <span class="text-sm font-semibold link-underline">
              <router-link :to="{ name: 'mastery#forgotPassword' }">
                Forgot password
              </router-link>
            </span>
          </div>
          <div class="divider">
            <span class="text-sm font-semibold">or</span>
          </div>
          <div class="social-buttons">
            <google-circle-button :mastery="true" />
            <facebook-circle-button :mastery="true" />
            <apple-circle-button :mastery="true" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppleCircleButton from '@/components/singletons/AppleCircleButton';
import FacebookCircleButton from '@components/singletons/FacebookCircleButton';
import GoogleCircleButton from '@/components/singletons/GoogleCircleButton';
import AuthenticationMixin from '@/mixins/authentication';
import MasteryIcon from '@components/mastery/MasteryIcon';
import AuthMasteryInput from '@components/ui/AuthMasteryInput';

export default {
  components: { AppleCircleButton, FacebookCircleButton, GoogleCircleButton, AuthMasteryInput, MasteryIcon },
  mixins: [AuthenticationMixin],
  data() {
    return {
      shake: false,
    };
  },
  computed: {
    signinTitle() {
      const prodVar = this.$store.getters['productVars/get']['sign_in_screen_detail'];
      return prodVar ? prodVar.value : 'Log in to your account';
    },
    signinSubTitle() {
      const prodVar = this.$store.getters['productVars/get']['sign_in_screen_subtitle'];
      return prodVar ? prodVar.value : 'Welcome back! Please enter your details.';
    },
    errorResponse() {
      return this.$store.getters['session/errorResponse'];
    },
    showDebug() {
      return this.$route.query.debug;
    },
  },
  created() {
    if (this.authenticated) {
      this.$router.push({name: 'home'});
    } else if (this.$route.query.email) {
      this.email = this.$route.query.email;
    }
  },
  methods: {
    submit() {
      // clear all validations
      this.clearAuthenticationErrors();
      this.loading = true;
      this.$store.dispatch('session/signIn', [{email: this.email, password: this.password}]).then(response => {
        const redirectAfterLogin = this.$cookie.get('redirectAfterLogin');

        if (redirectAfterLogin) {
          this.$router.push({ path: decodeURI(redirectAfterLogin) }, () => {
            this.$cookie.delete('redirectAfterLogin');
          });
        } else {
          this.$router.push({ name: 'home' });
        }
      }).catch(e => {
        this.shake = true;
        setTimeout(function(){this.shake = false;}.bind(this), 250);
        this.handleErrors(e, 'Sign In');
        this.loading = false;
      });
    },
  },
};
</script>

<style lang='scss' scoped>
  @import '@/style/authentication-v2.scss';

  .shake {
    animation: shake 0.5s infinite;
  }
  @keyframes shake {
    0% {
      transform: translate(0);
    }
    20% {
      transform: translate(1em);
    }
    40% {
      transform: translate(-1em);
    }
    60% {
      transform: translate(1em);
    }
    80% {
      transform: translate(-1em);
    }
    100% {
      transform: translate(0);
    }
  }

  .debug-message {
    color: darkred;
    padding: 1rem;
    text-align: left;
    margin-top: 2rem;
    border: 1px solid darkred;
  }

  .margin-bottom-1 {
    margin-bottom: rem-calc(16);
  }
</style>
